module.exports = __webpack_public_path__ + "media/landmark.4cd0a076.jpg";